export default "__VITE_ASSET__CEdhRhVi__"